
const digest = 'ce854839c838adc44611722dff86d0f1d2571ae840091cb04bf78d5df64e40b9';
const classes = {"wrapper":"_wrapper_1wrht_1","customButtonsWrapper":"_customButtonsWrapper_1wrht_9"};
const css = `._wrapper_1wrht_1 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  font-family: "Rubik", sans-serif;
}

._customButtonsWrapper_1wrht_9 {
  background-color: #e7effa;
  padding: 18px;
  border-radius: 41px;
  display: flex;
  flex-direction: row;
  width: auto;
  gap: 15px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  